<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  source: { type: Object, required: true },
});

const { t } = useI18n();
const bot = computed(() => props.source.bot || {});
const isBot = computed(() => bot.value.handled_by !== 'agent');

const intentLabel = computed(() => {
  if (!bot.value.intent) return '';
  const key = `MULTICHAT.SOURCE.BOT.INTENTS.${bot.value.intent.toUpperCase()}`;
  return t(key) === key ? bot.value.intent : t(key);
});
</script>

<template>
  <div
    class="flex items-center gap-3 p-3 rounded-lg bg-n-alpha-1 border border-n-weak"
  >
    <span
      class="grid flex-shrink-0 size-10 rounded-full place-items-center bg-gradient-to-br from-[#E30611] to-[#B0040D] text-white"
    >
      <span class="i-lucide-bot size-5" />
    </span>
    <div class="flex flex-col min-w-0 flex-1 gap-1">
      <div class="flex items-center gap-1.5 min-w-0">
        <span class="text-[13px] font-semibold text-n-slate-12">
          {{ bot.name || t('MULTICHAT.SOURCE.BOT.DEFAULT_NAME') }}
        </span>
        <span class="text-[11px] text-n-slate-10 truncate">
          {{ t('MULTICHAT.SOURCE.BOT.SUBTITLE') }}
        </span>
      </div>
      <div class="flex flex-wrap items-center gap-1.5">
        <span
          class="inline-flex items-center gap-1 h-5 px-1.5 rounded-md text-[11px] font-semibold"
          :class="
            isBot ? 'bg-n-iris-3 text-n-iris-11' : 'bg-n-blue-3 text-n-blue-11'
          "
        >
          <span
            class="size-3"
            :class="isBot ? 'i-lucide-bot' : 'i-lucide-headset'"
          />
          {{
            isBot
              ? t('MULTICHAT.SOURCE.BOT.HANDLED_BY_BOT')
              : t('MULTICHAT.SOURCE.BOT.HANDLED_BY_AGENT')
          }}
        </span>
        <span
          v-if="intentLabel"
          class="inline-flex items-center gap-1 h-5 px-1.5 rounded-md bg-n-alpha-2 text-[11px] font-medium text-n-slate-12"
        >
          <span class="i-lucide-target size-3 text-n-slate-10" />
          {{ intentLabel }}
        </span>
        <span
          v-if="bot.resolved_by_bot"
          class="inline-flex items-center gap-1 h-5 px-1.5 rounded-md bg-n-teal-3 text-n-teal-11 text-[11px] font-semibold"
        >
          <span class="i-lucide-circle-check size-3" />
          {{ t('MULTICHAT.SOURCE.BOT.RESOLVED') }}
        </span>
      </div>
    </div>
  </div>
</template>
